module.exports = __webpack_public_path__ + "img/culture_active5.7dd475a9.png";